module.exports = __webpack_public_path__ + "static/langojango-russian-language-phrasebook-9c2c68fc20cd218ab58cfc540ba81ced.png";